"use client";

import { c as _c } from "react/compiler-runtime";
import { useAdContext } from "./AdContextProvider";
import { AdSlot } from "./AdSlot";
import { StackedWallpaperRails } from "./StackedWallpaperRails";
interface WallpaperLayoutProps {
  mode: "none" | "sides" | "sides-stacked" | "skin";
}
const CONTENT_HALF = "43.75rem"; // half of max-w-350 (87.5rem)

const railBase: React.CSSProperties = {
  position: "fixed",
  top: "calc(var(--nav-total-height, 120px) + 20px)",
  bottom: 0,
  zIndex: 20,
  pointerEvents: "none"
};
const leftRailStyle: React.CSSProperties = {
  ...railBase,
  right: `calc(50% + ${CONTENT_HALF})`
};
const rightRailStyle: React.CSSProperties = {
  ...railBase,
  left: `calc(50% + ${CONTENT_HALF})`
};
const adContentStyle: React.CSSProperties = {
  pointerEvents: "auto"
};
const topBannerStyle: React.CSSProperties = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 0
};
export function WallpaperLayout(t0) {
  const $ = _c(17);
  const {
    mode
  } = t0;
  const adContext = useAdContext();
  if (mode === "none" || !adContext) {
    return null;
  }
  if (mode === "sides-stacked") {
    const hasLeftTop = !!adContext.slots["wallpaper-left-top"];
    const hasLeftBottom = !!adContext.slots["wallpaper-left-bottom"];
    const hasRightTop = !!adContext.slots["wallpaper-right-top"];
    const hasRightBottom = !!adContext.slots["wallpaper-right-bottom"];
    if (!hasLeftTop && !hasLeftBottom && !hasRightTop && !hasRightBottom) {
      return null;
    }
    let t1;
    if ($[0] !== hasLeftBottom || $[1] !== hasLeftTop || $[2] !== hasRightBottom || $[3] !== hasRightTop) {
      t1 = <StackedWallpaperRails hasLeftTop={hasLeftTop} hasLeftBottom={hasLeftBottom} hasRightTop={hasRightTop} hasRightBottom={hasRightBottom} />;
      $[0] = hasLeftBottom;
      $[1] = hasLeftTop;
      $[2] = hasRightBottom;
      $[3] = hasRightTop;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  const hasLeftSlot = !!adContext.slots["wallpaper-left"];
  const hasRightSlot = !!adContext.slots["wallpaper-right"];
  const hasTopSlot = !!adContext.slots["wallpaper-top"];
  const showSides = (mode === "sides" || mode === "skin") && (hasLeftSlot || hasRightSlot);
  const showTop = mode === "skin" && hasTopSlot;
  if (!showSides && !showTop) {
    return null;
  }
  let t1;
  if ($[5] !== showTop) {
    t1 = showTop && <div style={topBannerStyle}><AdSlot id="wallpaper-top" /></div>;
    $[5] = showTop;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== hasLeftSlot || $[8] !== showSides) {
    t2 = showSides && hasLeftSlot && <div className="wallpaper-rail" style={leftRailStyle}><div style={adContentStyle}><AdSlot id="wallpaper-left" /></div></div>;
    $[7] = hasLeftSlot;
    $[8] = showSides;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== hasRightSlot || $[11] !== showSides) {
    t3 = showSides && hasRightSlot && <div className="wallpaper-rail" style={rightRailStyle}><div style={adContentStyle}><AdSlot id="wallpaper-right" /></div></div>;
    $[10] = hasRightSlot;
    $[11] = showSides;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}